<template>
  <div>
    <h3>≪注意事項≫</h3>
    <p class="mb-0 attention">・解約後、再度サービスを開始する場合は、新規契約となります</p>
    <p class="mb-0 attention" v-bind:class="{ alert: isActiveAlert }">{{attention}}</p>
    <p class="mb-0 attention">・解約理由をお聞かせください【必須】</p>
    <v-checkbox
      class="mt-2"
      v-for="choice in choices"
      :key="choice.id"
      v-model="selectedReason"
      :label="choice.text"
      :value="choice.id"
      hide-details
      :disabled="isConfirm"
      color="secondary"
    ></v-checkbox>

    <template v-if="selectedReason.includes(7)">
      <v-textarea
        outlined
        color="secondary"
        class="mt-4"
        style="width:400px;"
        hide-details
        solo
        :disabled="isConfirm"
        v-model="message"
      />
      <p class="counter">{{message.length}} / 200</p>
    </template>

    <p class="mt-4 mb-0 pl-0 attention">※解約に同意する場合は、下記に解約申請者名を入力して、解約申請ボタンを押してください。</p>
    <v-text-field
      class="text-field mt-2"
      v-model="name"
      label="解約申請者名"
      outlined
      required
      hide-details
      dense
      :disabled="isConfirm"
      color="secondary"
    ></v-text-field>

    <!-- 確認ボタン -->
    <v-btn
      v-if="!isConfirm"
      class="float-right mt-6 confirm__btn"
      small
      :disabled="disabled || !name"
      @click="onClickConfirm">
      解約申請
    </v-btn>
  </div>
</template>

<script>

import { mapState, mapGetters } from 'vuex'

export default {
  components: {
  },

  props: {
    isConfirm: {
      type: Boolean,
      default: false,
    }
  },

  data(){
    return {
      choices: [
        { id: 1, text: "利用頻度が低い"},
        { id: 2, text: "学習効果が期待できなかった"},
        { id: 3, text: "料金に不満があった"},
        { id: 4, text: "サービスに不満があった"},
        { id: 5, text: "他社のシステムに乗り換える"},
        { id: 6, text: "利用する生徒がいなくなった"},
        { id: 7, text: "その他（200文字程度以内）"},
      ],
      today: new Date().getDate()
    }
  },

  watch: {},

  computed: {
    ...mapState('enrollment', [
      'selectedClassroomIds'
    ]),
    ...mapGetters('enrollment', [
      'isCancelClassroom'
    ]),
    selectedReason: {
      get () {
        return this.$store.state.enrollment.cancelForm.selectedReason
      },
      set (value) {
        this.$store.commit('enrollment/setCancelFormPayload', {
          selectedReason: value
        })
      }
    },
    message: {
      get () {
        return this.$store.state.enrollment.cancelForm.message
      },
      set (value) {
        this.$store.commit('enrollment/setCancelFormPayload', {
          message: value
        })
      }
    },
    name: {
      get () {
        return this.$store.state.enrollment.cancelForm.name
      },
      set (value) {
        this.$store.commit('enrollment/setCancelFormPayload', {
          name: value
        })
      }
    },
    disabled() {
      if (this.selectedReason.length === 0) return true
      return this.selectedReason.includes(7) && !this.message
    },
    attention() {
      let msg = ''
      if(this.today <= 25) {
        //解約申込日が１〜25日の場合
        msg = '・ご利用は、今月末までとなります'
      } else if(26 <= this.today) {
        //解約申込日が26日〜末日の場合
        msg = '・ご利用は、翌月末までとなります（ご請求は翌月分まで発生します）'
      }
      return msg
    },
    isActiveAlert() {
      return 26 <= this.today ? true : false
    }
  },

  methods: {
    onClickConfirm() {
      this.$emit('click-confirm')
    }
  }
}
</script>

<style lang="stylus">
.text-field
  min-height 10px !important
</style>

<style lang="stylus" scoped>
.attention
  font-size 14px
  margin-bottom 5px

.text-field
  width 200px
  background-color white

.confirm__btn
  background-color #D65B5B !important
  border-color #D05353 !important
  color white

.counter
  padding 1px 5px
  width 400px
  font-size 13px
  color gray
  text-align right

.alert
  color #FF0000
</style>
